module.exports = __webpack_public_path__ + "static/media/steroid-injection-for-joints-1-x@3x.e2dfad9e.jpg";